import React, { useState, useEffect } from "react";
import axios from "axios";

const TableFour1 = props => {
  const API = props.API;

  const [N, setN] = useState([0, 0, 0]);
  const [N1, setN1] = useState([0, 0, 0]);
  const [FYL, setFYL] = useState([0]);
  const [editable, setEditable] = useState(false);

  const submitForm = data => {
    var settings = {
      url: API + "/sectionfourone-create",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      data: {
        er: data.er,
        fyl: data.fyl,
        n: data.n,
        n1: data.n1
      }
    };

    axios(settings)
      .then(res => {
        console.log("Database Stored");
        console.log(res.data);
      })
      .catch(err => {
        console.log(err);
      });
  };

  useEffect(() => {
    var settings = {
      url: API + "/sectionfourone-get",
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    };

    axios(settings)
      .then(res => {
        let n = res.data.n;
        let n1 = res.data.n1;
        let fyl = res.data.fyl;

        setN(n);
        setN1(n1);
        setFYL(fyl);
      })
      .catch(err => {
        console.log(err);
      });
  }, []);

  const changeData = (type, val, index, previousData) => {
    val = Number(val);

    switch (type) {
      case "N":
        if (index === 0) setN([val, previousData[1], previousData[2]]);
        if (index === 1) setN([previousData[0], val, previousData[2]]);
        if (index === 2) setN([previousData[0], previousData[1], val]);
        break;
      case "N1":
        if (index === 0) setN1([val, previousData[1], previousData[2]]);
        if (index === 1) setN1([previousData[0], val, previousData[2]]);
        if (index === 2) setN1([previousData[0], previousData[1], val]);
        break;
      case "FYL":
        setFYL([val]);
        break;
      default:
        console.log("Default");
    }
  };

  return (
    <div>
      <h2>Table 4.1 Enrolment Ratio (20) </h2>
      <h3>Enrolment Ratio= N1/N</h3>
      <table border="1" cellPadding="10" width="80%">
        <tbody>
          {/* Heading */}
          <tr>
            <th>Item</th>
            <th>
              CAY <br /> (2017-2018)
            </th>
            <th>
              CAYm1 <br /> (2016-2017)
            </th>
            <th>
              CAYm2 <br /> (2015-2016)
            </th>
          </tr>

          {/* N */}
          <tr>
            <td>Sanctioned intake of the program (N) </td>
            {N.map((d, index) => {
              if (editable)
                return (
                  <td key={index}>
                    <input
                      type="number"
                      value={d}
                      onChange={e =>
                        changeData("N", e.target.value, index, [
                          N[0],
                          N[1],
                          N[2]
                        ])
                      }
                    />
                  </td>
                );
              else return <td key={index}>{d}</td>;
            })}
          </tr>

          {/* N1 */}
          <tr>
            <td>
              Total number of students admitted in first year minus number of
              students migrated to other programs/institutions plus no. of
              students migrated to this program (N1)
            </td>
            {N1.map((d, index) => {
              if (editable)
                return (
                  <td key={index}>
                    <input
                      type="number"
                      value={d}
                      onChange={e =>
                        changeData("N1", e.target.value, index, [
                          N1[0],
                          N1[1],
                          N1[2]
                        ])
                      }
                    />
                  </td>
                );
              else return <td key={index}>{d}</td>;
            })}
          </tr>

          {/* ER */}
          <tr>
            <td>Enrolment Ratio = N1/N</td>
            <td>{Math.trunc(N1[0] / N[0]).toString()}</td>
            <td>{Math.trunc(N1[1] / N[1]).toString()}</td>
            <td>{Math.trunc(N1[2] / N[2]).toString()}</td>
          </tr>

          {/* FYL */}
          <tr>
            <td>
              Students enrolled at the First Year Level on average basis during
              the last three years starting from current academic years
            </td>
            {editable ? (
              <td colSpan="3">
                <input
                  type="number"
                  value={FYL}
                  onChange={e => changeData("FYL", e.target.value)}
                />
              </td>
            ) : (
              <td colSpan="3">{FYL}</td>
            )}
          </tr>
        </tbody>
      </table>
      {editable ? null : (
        <button onClick={() => setEditable(true)}>Edit</button>
      )}
      &nbsp;
      <button
        onClick={() => {
          setEditable(false);

          var data = {
            n: N,
            n1: N1,
            er: [
              Math.trunc(N1[0] / N[0]),
              Math.trunc(N1[1] / N[1]),
              Math.trunc(N1[2] / N[2])
            ],
            fyl: FYL
          };

          submitForm(data);
        }}
      >
        Submit
      </button>
      <h2>Table B 4.1 </h2>
      <table border="1" cellPadding="10" width="80%">
        <tbody>
          {/* Heading */}
          <tr>
            <th>
              Item <br /> (Students enrolled at the First Year Level on average
              basis during the last three years starting from current academic
              years)
            </th>
            <th>Marks</th>
          </tr>
          <tr>
            <td>>=90% students enrolled </td>
            <td>20 </td>
          </tr>
          <tr>
            <td>>=80% students enrolled </td>
            <td>18 </td>
          </tr>
          <tr>
            <td>>=70% students enrolled </td>
            <td>16 </td>
          </tr>
          <tr>
            <td>>=60% students enrolled </td>
            <td>14 </td>
          </tr>
          <tr>
            <td>>=50% students enrolled </td>
            <td>12 </td>
          </tr>
          <tr>
            <td>Otherwise</td>
            <td>0</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default TableFour1;
